import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Conta',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Gerir conta',
      description: 'Mantenha a sua conta atualizada e gira as suas definições.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Métodos de pagamento',
      description: 'Adicione, altere ou selecione o seu método de pagamento preferido.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Ajuda e FAQs',
    },
    [AccountItemEnum.Logout]: {
      title: 'Terminar sessão',
    },
    [AccountItemEnum.Language]: {
      title: 'Idioma',
    },
  },
};
